import { ConstructorCardContent } from '@/core/components/Card/components/ConstructorCardContent'
import { CallableTitle } from '@/core/hooks/useCardNavigation/components/CallableTitle'
import { createNavigationCardItem } from '@/core/hooks/useCardNavigation/utils/createNavigationCardItem'
import { getBadgeLabel } from '@/core/hooks/useCardNavigation/utils/getBadgeLabel'
import { getParameterNamesSummary } from '@/core/hooks/useCardNavigation/utils/getParameterNamesSummary'
import type { ClassData, ConstructorData, LibraryData } from '@/core/types/library.type'

interface BuildConstructorEntriesParams {
  classData: ClassData
  library: LibraryData
  openAccordions: string[]
  onAccordionToggle: (itemId: string) => void
}

export const buildConstructorEntries = ({
  classData,
  library,
  openAccordions,
  onAccordionToggle,
}: BuildConstructorEntriesParams) =>
  classData.constructors
    ? Object.entries(classData.constructors).map(([constructorKey, constructor]: [string, ConstructorData]) => {
        const badge = getBadgeLabel(constructor.type)
        const title = <CallableTitle name={constructor.name} parameters={constructor.parameters} />

        const content = (
          <ConstructorCardContent
            constructor={constructor}
            constructorKey={constructorKey}
            classData={classData}
            runtimeName={library.runtimeName}
          />
        )

        return createNavigationCardItem({
          id: constructorKey,
          title,
          name: constructor.name,
          badge,
          description: getParameterNamesSummary(constructor.parameters),
          content,
          isOpen: openAccordions.includes(constructorKey),
          onAccordionToggle,
        })
      })
    : []
